import {
  ButtonPrimary,
  ButtonPseudo,
  Checkbox,
  IconSearch,
  InputText,
  SidePanel,
  SidePanelLoader,
  SidePanelType,
} from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import { ChangeTariffPanelTypes } from '../types';
import { OrganizationType } from '../../types';
import { setTariffSearchValue } from '../../store/slices/tariff/tariff';

import cn from '../styles.module.css';

const ChangeTariffPanel = ({
  isLoading,
  tariffsList,
  setSelectedTariffId,
  selectedTariffId,
  type,
  panelIsOpen,
  handleClose,
  tariffChangeInProgress,
  assignTariffToCustomerAction,
  searchValue,
}: ChangeTariffPanelTypes) => {
  const { baseInformation } = useAppSelector(
    (state) => state.individualCustomers.info.general,
  );
  const { baseInformation: corporateBaseInformation } = useAppSelector(
    (state) => state.corporateCustomers.info.general,
  );
  const { riskScoreRanges } = useAppSelector((state) => state.customerTariffs);

  const tariffInfo =
    type === OrganizationType.INDIVIDUAL
      ? baseInformation
      : corporateBaseInformation;

  const dispatch = useAppDispatch();

  let tariffsContent;

  if (isLoading) {
    tariffsContent = <SidePanelLoader />;
  } else {
    tariffsContent = (
      <div>
        {tariffsList
          ?.filter((item) => item.id !== tariffInfo?.tariffId)
          ?.map((item) => (
            <div className={cn.tariffRadioWrapper} key={item.id}>
              <div className={cn.tariffRadioValue}>
                <Checkbox
                  name={`radio-${item.id}`}
                  title={item.name}
                  type="radio"
                  onChange={() => setSelectedTariffId(item.id)}
                  checked={Boolean(selectedTariffId === item.id)}
                  visualClassName={cn.tariffRadioName}
                />
              </div>
              <div className={cn.tariffRadioValue}>
                {
                  riskScoreRanges.find(
                    (range) => range.value === item.riskScoreRangeId,
                  )?.name
                }
              </div>
            </div>
          ))}
      </div>
    );
  }

  return (
    <SidePanel
      type={SidePanelType.Accounts}
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={handleClose}
      title={`Change tariff to ${
        type === OrganizationType.INDIVIDUAL
          ? `${baseInformation?.firstName} ${baseInformation?.lastName}`
          : corporateBaseInformation?.name
      }`}
      sidepanelExpandedKey="customers-change-tariff"
      footer={
        <>
          <ButtonPrimary
            text={tariffChangeInProgress ? 'Loading...' : 'Apply'}
            onClick={() => assignTariffToCustomerAction()}
            disabled={
              Boolean((tariffInfo?.tariffId as string) === selectedTariffId) ||
              !selectedTariffId
            }
            bold
          />
          <ButtonPseudo text="Close" onClick={handleClose} bold />
        </>
      }
    >
      <>
        <div className={cn.tariffSearchWrapper}>
          <InputText
            name="searchValue"
            value={searchValue}
            placeholder="Search tariff..."
            prefix={<IconSearch />}
            onChange={(e) => dispatch(setTariffSearchValue(e.target.value))}
            prefixClassName={cn.tariffSearchPrefix}
            className={cn.tariffSearch}
          />
        </div>
        <div className={cn.tariffHeader}>
          <div className={cn.tariffValue}>Tariff</div>
          <div className={cn.tariffValue}>Risk score</div>
        </div>
        {tariffsContent}
      </>
    </SidePanel>
  );
};

export default ChangeTariffPanel;
